import parse from './parse'

const onProcessRule = (rule) => {
  if (typeof rule.style === 'string') {
    rule.style = parse(rule.style)
  }
}

export default () => ({onProcessRule})



// WEBPACK FOOTER //
// ./src/index.js